module.exports = __webpack_public_path__ + "img/yaoshi_zhongji.923c3711.png";